import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import EqualizerIcon from '@mui/icons-material/Equalizer';

import Typography from '@ts-core/components/Typography';
import NavigationTabBar, { NavigationTabBarProps } from '@ts-core/core/components/NavigationTabBar';

interface RankingsPageHeaderProps extends NavigationTabBarProps {}

const RankingsPageHeader = (props: RankingsPageHeaderProps) => {
  const intl = useIntl();
  const { tabs, activeTab, onGoToTab } = props;

  return (
    <Box textAlign="center">
      <EqualizerIcon fontSize="large" sx={{ fontSize: 72 }} />
      <Typography variant="h6" mt={-1} fontSize={32}>
        {intl.formatMessage({ id: 'quickLink.rankings' })}
      </Typography>
      <NavigationTabBar sx={{ borderTop: 'unset' }} tabs={tabs} activeTab={activeTab} onGoToTab={onGoToTab} />
    </Box>
  );
};

export default RankingsPageHeader;
